import ListItem from './ListItem';
import styled from 'styled-components';
import { ListItemData } from '../utils/mapData';
import TelaDocItem from './TelaDocItem';
import { CustomPagination } from 'components';

const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

type NetworkListProps = {
  setPage: (page: number) => void;
  page: number;
  items: ListItemData[];
  total?: number;
  handleOnListItemSelected: (rowId: number | string, latitude: number, longitude: number) => void;
  currentRowId: number | string | undefined;
  isShowTeladoc?: boolean;
  pageSize: number;
  searchQuery?: string;
};
export const NetworkList = ({
  items = [],
  total,
  setPage,
  page,
  handleOnListItemSelected,
  currentRowId,
  isShowTeladoc,
  pageSize,
  searchQuery,
}: NetworkListProps): JSX.Element => {
  return (
    <ListItemWrapper>
      {isShowTeladoc && <TelaDocItem />}
      {items.map((data) => (
        <ListItem
          key={`ListItem.${data.itemId}`}
          isActive={data.itemId === currentRowId}
          handleOnListItemSelected={handleOnListItemSelected}
          data={data}
          searchQuery={searchQuery}
        />
      ))}
      {items && (
        <CustomPagination
          pageSize={pageSize}
          defaultCurrent={page}
          current={page}
          total={total}
          showSizeChanger={false}
          onChange={setPage}
        />
      )}
    </ListItemWrapper>
  );
};
